/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_IntegrationsInputs */

const cs_nav_integrations = /** @type {(inputs: Nav_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrace`)
};

const en_nav_integrations = /** @type {(inputs: Nav_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations`)
};

/**
* | output |
* | --- |
* | "Integrations" |
*
* @param {Nav_IntegrationsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_integrations = /** @type {((inputs?: Nav_IntegrationsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_IntegrationsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_integrations(inputs)
	return cs_nav_integrations(inputs)
});